<div>
    <nz-spin [nzSpinning]="spinnn" >
    <form nz-form>
        <div nz-row nzGutter="16">
            <div nz-col nzSpan="14">
                <div nz-col class="my-box" nzSpan="24">
                    <nz-form-item>
                        <nz-form-label nzNoColon><b>Project :</b></nz-form-label>
                        <!-- <nz-form-control>
                        <nz-select name="projectName" nzShowSearch nzAllowClear (ngModelChange)="onProjectChange($event)" nzPlaceHolder="Select a Project" [(ngModel)]="moduleData.PROJECT_ID" nzDisabled>
                            <nz-option *ngFor="let project of projectList" [nzValue]="project.ID" [nzLabel]="project.NAME"></nz-option>
                        </nz-select>
                        </nz-form-control> -->

                        <p>{{moduleData['PROJECT_NAME']}}</p>
                    </nz-form-item>
                </div>

                <div nz-col nzSpan="24">
                    <nz-form-item>
                        <div nz-row>
                            <div nz-col nzSpan="2">
                                <div style="margin-right: 5px; margin-top: -2px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 46 46">
                                        <g id="Epic_Icon" data-name="Epic Icon" transform="translate(-317 -1801)">
                                            <rect id="Rectangle_62" data-name="Rectangle 62" width="46" height="46"
                                                rx="6" transform="translate(317 1801)" fill="#904ee2" />
                                            <path id="Union_1" data-name="Union 1"
                                                d="M9.849,16.819H0L10.151,0V10.005H20L9.849,26.824Z"
                                                transform="translate(330 1811)" fill="#fff" />
                                        </g>
                                    </svg>
                                </div>
                            </div>

                            <div nz-col nzSpan="22">
                                <div>
                                    <b>
                                        <p nz-typography nzEditable [(nzContent)]="moduleData.NAME"
                                            (nzContentChange)="onContentNameChange($event)"></p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </nz-form-item>
                </div>

                <div nz-col class="my-box" nzSpan="24">
                    <nz-form-item>
                        <nz-form-label nzNoColon><b>Description :</b></nz-form-label>
                        <p nz-typography nzEditable [(nzContent)]="moduleData.DESCRIPTION"
                            (nzContentChange)="onContentDescriptionChange($event)"></p>
                    </nz-form-item>
                </div>

                <div nz-col class="my-box" nzSpan="24">
                    <nz-form-item>
                        <nz-form-label nzNoColon><b>Features :</b></nz-form-label>

                        <div style="text-align: center;" *ngIf="isFeatureSpinning">
                            <nz-spin nzSimple></nz-spin>
                        </div>

                        <div *ngIf="!isFeatureSpinning" nz-row>
                            <div *ngFor="let feature of featureData" nz-col nzSpan="24">
                                <div nz-row>
                                    <div nz-col nzSpan="24">
                                        <div style="display: flex;">
                                            <div style="margin-right: 5px; margin-top: -2px;">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                    viewBox="0 0 46 46">
                                                    <g id="Story_icon" data-name="Story icon"
                                                        transform="translate(-317 -1801)">
                                                        <rect id="Rectangle_62" data-name="Rectangle 62" width="46"
                                                            height="46" rx="6" transform="translate(317 1801)"
                                                            fill="#63ba3c" />
                                                        <path id="Path_23" data-name="Path 23"
                                                            d="M19.8,2.475V26.4L9.9,20.625,0,26.4V2.475A2.476,2.476,0,0,1,2.475,0h14.85A2.476,2.476,0,0,1,19.8,2.475Z"
                                                            transform="translate(330.2 1810.9)" fill="#fff" />
                                                    </g>
                                                </svg>
                                            </div>

                                            <div>
                                                {{feature.NAME}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nz-form-item>
                </div>

                <div nz-col nzSpan="24">
                    <nz-form-item>
                        <div nz-row style="display: flex;">
                            <div nz-col nzSpan="12" style="text-align: left;">
                                <nz-form-label nzNoColon><b>Attachments :</b></nz-form-label>
                            </div>

                            <div nz-col nzSpan="12" style="text-align: right;">
                                <span style="cursor: pointer;" (click)="addAttachment()">
                                    <svg nzTooltipTitle="Add New" nzTooltipPlacement="top" nz-tooltip
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="40" height="40" viewBox="0 0 40 40"
                                        style="margin-top: -5px; margin-left: -8px;">
                                        <defs>
                                            <filter id="Ellipse_1" x="0" y="0" width="40" height="40"
                                                filterUnits="userSpaceOnUse">
                                                <feOffset input="SourceAlpha" />
                                                <feGaussianBlur stdDeviation="3" result="blur" />
                                                <feFlood flood-color="#4892ff" flood-opacity="0.361" />
                                                <feComposite operator="in" in2="blur" />
                                                <feComposite in="SourceGraphic" />
                                            </filter>
                                        </defs>
                                        <g id="Attachment_Icon" data-name="Attachment Icon"
                                            transform="translate(-523 -350)">
                                            <g transform="matrix(1, 0, 0, 1, 523, 350)" filter="url(#Ellipse_1)">
                                                <circle id="Ellipse_1-2" data-name="Ellipse 1" cx="11" cy="11" r="11"
                                                    transform="translate(9 9)" fill="#e8f1ff" />
                                            </g>
                                            <g id="Group_2" data-name="Group 2" transform="translate(4 3.9)">
                                                <path id="Path_2" data-name="Path 2" d="M543,361.1v10"
                                                    transform="translate(-4)" fill="none" stroke="#0061f3"
                                                    stroke-linecap="round" stroke-width="1" />
                                                <path id="Path_3" data-name="Path 3" d="M0,0V10"
                                                    transform="translate(544 366.1) rotate(90)" fill="none"
                                                    stroke="#0061f3" stroke-linecap="round" stroke-width="1" />
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </div>
                        </div>

                        <div style="text-align: center;" *ngIf="isAttachmentSpinning">
                            <nz-spin nzSimple></nz-spin>
                        </div>

                        <div *ngIf="!isAttachmentSpinning" nz-row>
                            <div *ngFor="let attachment of attachmentData" nz-col nzSpan="12">
                                <div>
                                    <div nz-row>
                                        <div nz-col nzSpan="20">
                                            <li><a href="{{this._apiService.retriveimgUrl}}Attachments/{{attachment.ATTACHMENT_URL}}"
                                                    target="_blank">{{attachment.ATTACHMENT_URL}}</a></li>
                                        </div>

                                        <div nz-col nzSpan="4">
                                            <i style="color: red; font-size: 15px;" nz-icon nzType="delete"
                                                nzTheme="outline"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nz-form-item>
                </div>
            </div>

            <div nz-col nzSpan="10">
                <div nz-col class="my-box" nzSpan="24">
                    <nz-form-item>
                        <nz-form-label nzNoColon><b>Status :</b></nz-form-label>

                        <nz-form-control>
                            <nz-select style="width: 100%;" name="status" nzShowSearch nzAllowClear
                                nzPlaceHolder="Select a Module Status" (ngModelChange)="onStatusChange($event)"
                                [(ngModel)]="moduleData.STATUS">
                                <nz-option nzLabel="Pending" nzValue="P"></nz-option>
                                <nz-option nzLabel="Started" nzValue="S"></nz-option>
                                <nz-option nzLabel="Completed" nzValue="C"></nz-option>
                                <nz-option nzLabel="On Hold" nzValue="OH"></nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col class="my-box" nzSpan="24">
                    <nz-form-item>
                        <div nz-row style="display: flex;">
                            <div nz-col nzSpan="22" style="text-align: left; margin-bottom: 5px;">
                                <nz-form-label nzNoColon><b>Assignee :</b></nz-form-label>
                            </div>

                            <div nz-col nzSpan="2"
                                *ngIf="this.cookie.get('level') == '1' || this.cookie.get('level') == '2' || this.cookie.get('level') == '3' || this.cookie.get('level') == '4'">
                                <nz-spin [nzSpinning]="spinnn" >
                                <span style="cursor: pointer;" (click)="mapModule(moduleData['ID'])"
                                    nzTooltipTitle="Map Team" nzTooltipPlacement="top" nz-tooltip>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"
                                        style="height: 16px; width: 20px; margin-top: 5px;">
                                        <path
                                            d="M512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM368 400c0-16.69 3.398-32.46 8.619-47.36C374.3 352.5 372.2 352 369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h266.1C389.5 485.6 368 445.5 368 400zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 21.47-5.625 41.38-14.65 59.34C462.2 263.4 486.1 256 512 256c42.48 0 80.27 18.74 106.6 48h3.756C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192zM618.1 366.7c-5.025-16.01-13.59-30.62-24.75-42.71c-1.674-1.861-4.467-2.326-6.699-1.023l-19.17 11.07c-8.096-6.887-17.4-12.28-27.45-15.82V295.1c0-2.514-1.861-4.746-4.281-5.213c-16.56-3.723-33.5-3.629-49.32 0C484.9 291.2 483.1 293.5 483.1 295.1v22.24c-10.05 3.537-19.36 8.932-27.45 15.82l-19.26-11.07c-2.139-1.303-4.932-.8379-6.697 1.023c-11.17 12.1-19.73 26.71-24.66 42.71c-.7441 2.512 .2793 5.117 2.42 6.326l19.17 11.17c-1.859 10.42-1.859 21.21 0 31.64l-19.17 11.17c-2.234 1.209-3.164 3.816-2.42 6.328c4.932 16.01 13.49 30.52 24.66 42.71c1.766 1.863 4.467 2.328 6.697 1.025l19.26-11.07c8.094 6.887 17.4 12.28 27.45 15.82v22.24c0 2.514 1.77 4.746 4.188 5.211c16.66 3.723 33.5 3.629 49.32 0c2.42-.4648 4.281-2.697 4.281-5.211v-22.24c10.05-3.535 19.36-8.932 27.45-15.82l19.17 11.07c2.141 1.303 5.025 .8379 6.699-1.025c11.17-12.1 19.73-26.7 24.75-42.71c.7441-2.512-.2773-5.119-2.512-6.328l-19.17-11.17c1.953-10.42 1.953-21.22 0-31.64l19.17-11.17C618.7 371.8 619.7 369.2 618.1 366.7zM512 432c-17.67 0-32-14.33-32-32c0-17.67 14.33-32 32-32s32 14.33 32 32C544 417.7 529.7 432 512 432z" />
                                    </svg>
                                </span>
                                </nz-spin>
                            </div>

                            <!-- <div nz-col nzSpan="2" style="text-align: right;">
                                <span style="cursor: pointer;" (click)="addAssignee()"
                                    *ngIf="this.cookie.get('level') == '1' || this.cookie.get('level') == '2' || this.cookie.get('level') == '3' || this.cookie.get('level') == '4'">
                                    <svg nzTooltipTitle="Add New" nzTooltipPlacement="top" nz-tooltip
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="40" height="40" viewBox="0 0 40 40"
                                        style="margin-top: -8px; margin-left: -8px;">
                                        <defs>
                                            <filter id="Ellipse_1" x="0" y="0" width="40" height="40"
                                                filterUnits="userSpaceOnUse">
                                                <feOffset input="SourceAlpha" />
                                                <feGaussianBlur stdDeviation="3" result="blur" />
                                                <feFlood flood-color="#4892ff" flood-opacity="0.361" />
                                                <feComposite operator="in" in2="blur" />
                                                <feComposite in="SourceGraphic" />
                                            </filter>
                                        </defs>
                                        <g id="Attachment_Icon" data-name="Attachment Icon"
                                            transform="translate(-523 -350)">
                                            <g transform="matrix(1, 0, 0, 1, 523, 350)" filter="url(#Ellipse_1)">
                                                <circle id="Ellipse_1-2" data-name="Ellipse 1" cx="11" cy="11" r="11"
                                                    transform="translate(9 9)" fill="#e8f1ff" />
                                            </g>
                                            <g id="Group_2" data-name="Group 2" transform="translate(4 3.9)">
                                                <path id="Path_2" data-name="Path 2" d="M543,361.1v10"
                                                    transform="translate(-4)" fill="none" stroke="#0061f3"
                                                    stroke-linecap="round" stroke-width="1" />
                                                <path id="Path_3" data-name="Path 3" d="M0,0V10"
                                                    transform="translate(544 366.1) rotate(90)" fill="none"
                                                    stroke="#0061f3" stroke-linecap="round" stroke-width="1" />
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </div> -->
                        </div>

                        <span *ngIf="!assignInputHidden">
                            <div nz-row nzGutter="5" style="margin-bottom: 7px;">
                                <div nz-col nzSpan="22">
                                    <nz-select [nzDropdownStyle]="{'width':'300px'}" name="assigneeNameForNewAdd"
                                        nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="Select Assignee"
                                        [(ngModel)]="ASSIGNEE_ID">
                                        <nz-option nzCustomContent *ngFor="let assignee of newAssigneeList"
                                            [nzValue]="assignee.USER_ID" [nzLabel]="assignee.USER_NAME">
                                            <div>
                                                {{assignee.USER_NAME}}
                                            </div>

                                            <div style="font-size: 12px; color: gray; text-align: right;">
                                                <span>~&nbsp;{{assignee.TASK_CATEGORY_NAME}}
                                                    ({{assignee.ROLE_NAME}})</span>
                                            </div>
                                        </nz-option>
                                    </nz-select>
                                </div>

                                <div nz-col nzSpan="2">
                                    <button *ngIf="ASSIGNEE_ID.length>0" nz-button nzType="primary" nzShape="circle"
                                        (click)="onAssigneeChange()"><i nz-icon nzType="check"
                                            nzTheme="outline"></i></button>
                                </div>
                            </div>
                        </span>

                        <span>
                            <div nz-row>
                                <div nz-col nzSpan="24" style="text-align: center;" *ngIf="isAssigneeSpinning">
                                    <nz-spin nzSimple></nz-spin>
                                </div>

                                <div nz-col nzSpan="24" *ngFor="let assigneeName of newAssigneesName; let i = index"
                                    style="display: inline-flex; margin-bottom: 7px;">
                                    <div>
                                        <nz-avatar [nzText]="generateBadge(assigneeName)"
                                            style="color:red; background-color:rgb(247, 218, 218); margin-top: -5px; margin-right: 3px;">
                                        </nz-avatar>
                                    </div>

                                    <div>
                                        {{ assigneeName }}
                                    </div>
                                </div>
                            </div>
                        </span>
                    </nz-form-item>

                    <nz-form-item>
                        <div style="margin-bottom: 5px;">
                            <nz-form-label nzNoColon><b>Reporter :</b>
                            </nz-form-label>
                        </div>

                        <div nz-row>
                            <div nz-col nzSpan="24" style="text-align: center;" *ngIf="isReporterSpinning">
                                <nz-spin nzSimple></nz-spin>
                            </div>

                            <div nz-col nzSpan="24" *ngFor="let reporterName of newReporterName; let i = index"
                                style="display: inline-flex; margin-bottom: 7px;">
                                <div>
                                    <nz-avatar [nzText]="generateBadge(reporterName)"
                                        style="color:red; background-color:rgb(247, 218, 218); margin-top: -5px; margin-right: 3px;">
                                    </nz-avatar>
                                </div>

                                <div>
                                    {{ reporterName }}
                                </div>
                            </div>
                        </div>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label nzNoColon><b>Start Date :</b>&nbsp;<span>
                                {{moduleData.START_DATE | date: 'dd MMM,yyyy'}}
                            </span></nz-form-label>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label nzNoColon><b>End Date :</b>&nbsp;<span>
                                {{moduleData.END_DATE | date: 'dd MMM,yyyy'}}
                            </span></nz-form-label>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label nzNoColon><b>Estimated Mandays
                                :</b>&nbsp;<span>{{moduleData.ESTIMATED_MANDAYS}}</span></nz-form-label>
                    </nz-form-item>

                    <nz-form-item>
                        <div nz-row style="margin-top: 3px; display: flex;">
                            <div nz-col nzSpan="22" style="text-align: left;">
                                <nz-form-label nzNoColon><b>Time Tracked
                                        :</b>&nbsp;<span>{{totalWorklogTime}}</span></nz-form-label>
                            </div>

                            <div nz-col nzSpan="2" style="text-align: right;">
                                <span style="cursor: pointer;" (click)="addWorklog()">
                                    <svg nzTooltipTitle="Add New" nzTooltipPlacement="top" nz-tooltip
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="40" height="40" viewBox="0 0 40 40"
                                        style="margin-top: -5px; margin-left: -8px;">
                                        <defs>
                                            <filter id="Ellipse_1" x="0" y="0" width="40" height="40"
                                                filterUnits="userSpaceOnUse">
                                                <feOffset input="SourceAlpha" />
                                                <feGaussianBlur stdDeviation="3" result="blur" />
                                                <feFlood flood-color="#4892ff" flood-opacity="0.361" />
                                                <feComposite operator="in" in2="blur" />
                                                <feComposite in="SourceGraphic" />
                                            </filter>
                                        </defs>
                                        <g id="Attachment_Icon" data-name="Attachment Icon"
                                            transform="translate(-523 -350)">
                                            <g transform="matrix(1, 0, 0, 1, 523, 350)" filter="url(#Ellipse_1)">
                                                <circle id="Ellipse_1-2" data-name="Ellipse 1" cx="11" cy="11" r="11"
                                                    transform="translate(9 9)" fill="#e8f1ff" />
                                            </g>
                                            <g id="Group_2" data-name="Group 2" transform="translate(4 3.9)">
                                                <path id="Path_2" data-name="Path 2" d="M543,361.1v10"
                                                    transform="translate(-4)" fill="none" stroke="#0061f3"
                                                    stroke-linecap="round" stroke-width="1" />
                                                <path id="Path_3" data-name="Path 3" d="M0,0V10"
                                                    transform="translate(544 366.1) rotate(90)" fill="none"
                                                    stroke="#0061f3" stroke-linecap="round" stroke-width="1" />
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </nz-form-item>
                </div>
            </div>
        </div>

        <nz-tabset [nzSelectedIndex]="1">
            <nz-tab nzTitle="Comment">
                <div style="display: flex;">
                    <div>
                        <b>New Comment</b>
                    </div>

                    <div>
                        <span style="cursor: pointer;" (click)="add()">
                            <svg nzTooltipTitle="Add New" nzTooltipPlacement="top" nz-tooltip
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40"
                                height="40" viewBox="0 0 40 40" style="margin-top: -8px;">
                                <defs>
                                    <filter id="Ellipse_1" x="0" y="0" width="40" height="40"
                                        filterUnits="userSpaceOnUse">
                                        <feOffset input="SourceAlpha" />
                                        <feGaussianBlur stdDeviation="3" result="blur" />
                                        <feFlood flood-color="#4892ff" flood-opacity="0.361" />
                                        <feComposite operator="in" in2="blur" />
                                        <feComposite in="SourceGraphic" />
                                    </filter>
                                </defs>
                                <g id="Attachment_Icon" data-name="Attachment Icon" transform="translate(-523 -350)">
                                    <g transform="matrix(1, 0, 0, 1, 523, 350)" filter="url(#Ellipse_1)">
                                        <circle id="Ellipse_1-2" data-name="Ellipse 1" cx="11" cy="11" r="11"
                                            transform="translate(9 9)" fill="#e8f1ff" />
                                    </g>
                                    <g id="Group_2" data-name="Group 2" transform="translate(4 3.9)">
                                        <path id="Path_2" data-name="Path 2" d="M543,361.1v10" transform="translate(-4)"
                                            fill="none" stroke="#0061f3" stroke-linecap="round" stroke-width="1" />
                                        <path id="Path_3" data-name="Path 3" d="M0,0V10"
                                            transform="translate(544 366.1) rotate(90)" fill="none" stroke="#0061f3"
                                            stroke-linecap="round" stroke-width="1" />
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </div>

                    <!-- <div nz-col nzSpan="12">
                        <nz-form-item>
                            <nz-form-label nzRequired nzNoColon>Comment</nz-form-label>
        
                            <nz-form-control nzHasFeedback>
                                <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 6 }" name="commentToSend" placeHolder="Enter a Comment" [(ngModel)]="COMMENT_TEXT_TO_SEND" required></textarea>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
        
                    <div nz-col nzSpan="12">
                        <nz-form-item>
                            <nz-form-label nzRequired nzNoColon>Tagged User</nz-form-label>
            
                            <nz-input-group>
                                <nz-select name="taggedUserToSend" nzMode="multiple" style="width: 100%;" nzShowSearch style="width: 100%" [(ngModel)]="TAGGED_USERS_TO_SEND">
                                    <nz-option *ngFor="let user of taggedUserList" [nzValue]="user.ID" [nzLabel]="user.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </nz-form-item>
                    </div>

                    <div nz-col nzSpan="24" style="text-align: right;">
                        <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSendCommentButtonSpinning" (click)="sendComment()"><span>Send</span></button>
                        <button type="button" class="ant-btn ant-btn-primary" nz-button (click)="commentClear()"><span>Clear</span></button>
                    </div> -->
                </div>

                <div nz-row>
                    <div nz-col nzSpan="24">
                        <div style="text-align: center;" *ngIf="isCommentSpinning">
                            <nz-spin nzSimple></nz-spin>
                        </div>

                        <div *ngIf="!isCommentSpinning">
                            <div nz-row>
                                <div nz-col nzSpan="24"
                                    style="border: solid 1px rgb(168, 167, 167); border-radius: 10px; margin-bottom: 3px; padding: 3px;"
                                    *ngFor="let comment of commentData">
                                    <div nz-row>
                                        <div nz-col nzSpan="24" style="display: inline-flex;">
                                            <div>
                                                <nz-avatar [nzText]="generateBadge(comment.USER_NAME)"
                                                    style="color:red; background-color:rgb(247, 218, 218); margin-top: 5px;">
                                                </nz-avatar>
                                            </div>

                                            <div>
                                                <!-- [nzDatetime]="getDateFormat(comment.COMMENT_DATETIME)" -->

                                                <nz-comment style="cursor: pointer;" [nzAuthor]="comment.USER_NAME"
                                                    nzDatetime="{{comment.COMMENT_DATETIME | date:'dd-MMM-yyyy'}}">
                                                    <nz-comment-content (click)="showModal(comment)">
                                                        <p>{{comment.COMMENT_TEXT}}</p>
                                                    </nz-comment-content>

                                                    <nz-comment-action *ngIf="comment.USER_ID== loggedUserID">
                                                        <a (click)="edit(comment)" style="color: gray;">Edit</a>
                                                    </nz-comment-action>

                                                    <nz-comment-action *ngIf="comment.USER_ID== loggedUserID">
                                                        <a style="color: gray;" nz-popconfirm
                                                            nzPopconfirmTitle="Are you sure delete this Comment?"
                                                            nzPopconfirmPlacement="bottom"
                                                            (nzOnConfirm)="handleConfirmForComment(comment)"
                                                            (nzOnCancel)="handleCancelForComment()">
                                                            Delete
                                                        </a>
                                                    </nz-comment-action>
                                                </nz-comment>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div nz-col nzSpan="24">
                                <div style="text-align: center;">
                                    <button nz-button nzType="primary" [nzLoading]="isLoadMoreButtonSpinning"
                                        [hidden]="isLoadMoreButtonHide" (click)="loadMoreCommentIDWise()"><i nz-icon
                                            nzType="plus"></i>Load More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-tab>

            <nz-tab nzTitle="Worklog">
                <div nz-row>
                    <div nz-col nzSpan="24">
                        <div style="text-align: center;" *ngIf="isWorklogSpinning">
                            <nz-spin nzSimple></nz-spin>
                        </div>

                        <div *ngIf="!isWorklogSpinning">
                            <div nz-row>
                                <div nz-col nzSpan="24"
                                    style="border: solid 1px rgb(168, 167, 167); border-radius: 10px; margin-bottom: 3px; padding: 3px;"
                                    *ngFor="let worklog of worklogData">
                                    <div nz-row>
                                        <div nz-col nzSpan="24" style="display: inline-flex;">
                                            <div>
                                                <nz-avatar [nzText]="generateBadge(worklog.USER_NAME)"
                                                    style="color:red; background-color:rgb(247, 218, 218); margin-top: 5px;">
                                                </nz-avatar>
                                            </div>

                                            <div>
                                                <!-- [nzDatetime]="getDateFormat(worklog.WORKED_DATETIME)" -->

                                                <nz-comment style="cursor: pointer;" [nzAuthor]="worklog.USER_NAME"
                                                    nzDatetime="{{worklog.WORKED_DATETIME | date:'dd-MMM-yyyy'}}">
                                                    <nz-comment-content (click)="showWorklogModal(worklog)">
                                                        <p>{{worklog.WORK_DESCRIPTION}}</p>
                                                    </nz-comment-content>

                                                    <nz-comment-action *ngIf="worklog.USER_ID== loggedUserID">
                                                        <a (click)="editWorklog(worklog)" style="color: gray;">Edit</a>
                                                    </nz-comment-action>

                                                    <nz-comment-action *ngIf="worklog.USER_ID== loggedUserID">
                                                        <a style="color: gray;" nz-popconfirm
                                                            nzPopconfirmTitle="Are you sure delete this Worklog?"
                                                            nzPopconfirmPlacement="bottom"
                                                            (nzOnConfirm)="handleConfirmForWorklog(worklog)"
                                                            (nzOnCancel)="handleCancelForWorklog()">
                                                            Delete
                                                        </a>
                                                    </nz-comment-action>
                                                </nz-comment>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div nz-col nzSpan="24">
                                <div style="text-align: center;">
                                    <button nz-button nzType="primary" [nzLoading]="isWorklogLoadMoreButtonSpinning"
                                        [hidden]="isWorklogLoadMoreButtonHide" (click)="loadMoreWorklogIDWise()"><i
                                            nz-icon nzType="plus"></i>Load More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nz-tab>
        </nz-tabset>
    </form>
</nz-spin>
</div>
<div *ngIf="drawerVisible">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="400" [nzVisible]="drawerVisible"
        [nzTitle]="drawerTitle" (nzOnClose)="drawerClose()" (nzKeyboard)="true">

        <app-comment-drawer [drawerClose]="callBackDrawerClose" [data]="commentDrawerData"
            [typeData]="typeForCommentDrawer" [typeIDData]="typeIDForCommentDrawer" ></app-comment-drawer>
    </nz-drawer>
</div>
<div *ngIf="worklogDrawerVisible">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="500" [nzVisible]="worklogDrawerVisible"
        [nzTitle]="worklogDrawerTitle" (nzOnClose)="worklogDrawerClose()" (nzKeyboard)="true">
        <app-worklog-drawer [drawerClose]="callBackWorklogDrawerClose" [data]="worklogDrawerData"
            [typeData]="typeForWorklogDrawer" [typeIDData]="typeIDForWorklogDrawer"
            [estimatedMandays]="estimatedMandays" [estimatedTime_Mandays]="'M'"></app-worklog-drawer>
    </nz-drawer>
</div>
<div *ngIf="attachmentDrawerVisible">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="400"
        [nzVisible]="attachmentDrawerVisible" [nzTitle]="attachmentDrawerTitle" (nzOnClose)="attachmentDrawerClose()"
        (nzKeyboard)="true">

        <app-attachment-drawer [drawerClose]="callBackAttachmentDrawerClose" [data]="attachmentDrawerData"
            [typeData]="typeForAttachmentDrawer" [typeIDData]="typeIDForAttachmentDrawer"></app-attachment-drawer>
    </nz-drawer>
</div>

<nz-modal [nzBodyStyle]="{ height: '400px' }" [(nzVisible)]="isVisible" [nzTitle]="modalName" nzWidth="30%"
    (nzOnCancel)="handleCancel()" [nzFooter]="null">

    <ng-container *nzModalContent>
        <div nz-row>
            <div nz-col nzSpan="24">
                <b>Comment : </b><br>
                {{commentText}}
            </div>

            <nz-divider nzText=""></nz-divider>

            <div nz-col nzSpan="24">
                <b>Comment Author : </b>
                <div style="text-align: center;" *ngIf="isAuthorUserLoading">
                    <nz-spin nzSimple></nz-spin>
                </div>
                <div *ngIf="!isAuthorUserLoading">
                    <nz-tag [nzColor]="'#87d068'">
                        {{ commentAuthor }}
                    </nz-tag>
                </div>
            </div>

            <nz-divider nzText=""></nz-divider>

            <div nz-col nzSpan="24">
                <b>Commented Date Time : </b><br>
                {{commentDateTime | date: 'dd MMM yyyy hh:mm a'}}
            </div>

            <nz-divider nzText=""></nz-divider>

            <div nz-col nzSpan="24">
                <b>Tagged Users : </b>
                <div style="text-align: center;" *ngIf="isTaggedUserLoading">
                    <nz-spin nzSimple></nz-spin>
                </div>
                <div *ngIf="!isTaggedUserLoading">
                    <nz-tag [nzColor]="'#87d068'" *ngFor="let tag of newTaggedUsersName; let i = index">
                        {{ tag }}
                    </nz-tag>
                </div>
            </div>
        </div>
    </ng-container>
</nz-modal>

<nz-modal [nzBodyStyle]="{ height: '400px' }" [(nzVisible)]="isWorklogVisible" [nzTitle]="worklogModalName"
    nzWidth="30%" (nzOnCancel)="handleWorklogCancel()" [nzFooter]="null">

    <ng-container *nzModalContent>
        <div nz-row>
            <div nz-col nzSpan="24">
                <b>Worklog Author : </b>
                <div style="text-align: center;" *ngIf="isWorklogAuthorUserLoading">
                    <nz-spin nzSimple></nz-spin>
                </div>
                <div *ngIf="!isWorklogAuthorUserLoading">
                    <nz-tag [nzColor]="'#87d068'">
                        {{ worklogAuthor }}
                    </nz-tag>
                </div>
            </div>

            <nz-divider nzText=""></nz-divider>

            <div nz-col nzSpan="12">
                <b>Start Date Time : </b><br>
                {{worklogStartDateTime | date: 'dd MMM, yyyy hh:mm a'}}
            </div>

            <div nz-col nzSpan="12">
                <b>End Date Time : </b><br>
                {{worklogEndDateTime | date: 'dd MMM, yyyy hh:mm a'}}
            </div>

            <nz-divider nzText=""></nz-divider>

            <div nz-col nzSpan="24">
                <b>Spent Time : </b><br>
                {{worklogSpentTime}}
            </div>

            <nz-divider nzText=""></nz-divider>

            <div nz-col nzSpan="24">
                <b>Description : </b><br>
                {{worklogDescription}}
            </div>
        </div>
    </ng-container>
</nz-modal>
<div *ngIf="mappingDrawerVisible">
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="1000" [nzVisible]="mappingDrawerVisible"
        [nzTitle]="mappingDrawerTitle" (nzOnClose)="mappingDrawerClose()" (nzKeyboard)="true">

        <app-module-mapping [drawerClose]="callBackMappingDrawerClose" [data]="moduleDrawerData"
            [mappingData]="moduleMappingDrawerData"></app-module-mapping>
    </nz-drawer>
</div>